import React, { useState } from 'react';
import Icon from '@/components/AppIcon';
import Button from '@/components/ui/Button';
import dayjs     from 'dayjs';          // only if you want to show renewal date
import relativeTime from 'dayjs/plugin/relativeTime';
dayjs.extend(relativeTime);

const planCatalog = [
{ 
level: 1, 
name: 'standard',  
price: 39,  
period: 'month',     
popular: false, 
description: 'Perfect for getting started', 
features: ['18 applications per month', 'AI resume optimization', 'Career Assessment'] 
},
{ 
level: 2, 
name: 'premium',   
price: 199, 
period: 'quarterly', 
popular: true,  
description: 'Most popular choice', 
features: ['Unlimited applications', 'AI resume optimization', 'Priority matching']  
},
{ 
level: 3, 
name: 'elite',     
price: 399, 
period: 'quarterly', 
popular: false, 
description: 'Best value for serious job seekers', 
features: ['Unlimited applications', 'AI resume optimization', 'Priority matching'] 
}
];


const SubscriptionStatus = ({profile,navigate}) => {
/* -------------------------------------------------- */
/* 1.  resolve real plan (fallback if null)         */
/* -------------------------------------------------- */
const currentMeta = planCatalog.find(p => p.name === (profile?.name)) || planCatalog[0]; // fallback Standard
const currentLevel = currentMeta.level;

const currentPlan = {
...currentMeta,
daysLeft : Math.max(0, dayjs(profile?.expiry).diff(dayjs(), 'day')),
autoRenew: profile?.package_auto_renew ?? true
};



/* -------------------------------------------------- */
/* 2.  helpers                                        */
/* -------------------------------------------------- */
const getColorClasses = (color) => {
const map = {
primary: 'bg-primary/10 text-primary',
success: 'bg-success/10 text-success',
warning: 'bg-warning/10 text-warning',
accent:  'bg-accent/10 text-accent'
};
return map[color] || map.primary;
};



const handleUpgrade = (SelectedPackage) => {
navigate('/billing', {
state: {
...SelectedPackage,
showChangePlanModal: true,
}
});

};

return (
<div className="bg-card border border-border rounded-lg p-6">
<div className="flex items-center justify-between mb-6">
<h3 className="text-base sm:text-lg font-semibold text-text-primary">Subscription Status</h3>
<div className="flex items-center space-x-2">
<div className="w-2 h-2 bg-success rounded-full"></div>
<span className="text-sm text-success font-medium">Active</span>
</div>
</div>
{/* Current Plan */}
<div className="bg-primary/5 border border-primary/20 rounded-lg p-4 mb-6">
<div className="flex items-center justify-between mb-3">
<div>
<h4 className="font-semibold capitalize text-text-primary">{currentPlan?.name} Package</h4>
<p className="text-sm text-text-secondary">
{currentPlan?.price}/{currentPlan?.period}
</p>
</div>
<div className="text-right">
<p className="text-sm text-text-secondary">Renews in</p>
<p className="font-semibold text-primary">{currentPlan?.daysLeft} days</p>
</div>
</div>

<div className="space-y-2 mb-4">
{currentPlan?.features?.map((feature, index) => (
<div key={index} className="flex items-center space-x-2">
<Icon name="Check" size={16} className="text-success" />
<span className="text-sm text-text-secondary">{feature}</span>
</div>
))}
</div>

<div className="flex items-center justify-between">
<div className="flex items-center space-x-2">
<Icon 
name={currentPlan?.autoRenew ? "RotateCcw" : "PauseCircle"} 
size={16} 
className={currentPlan?.autoRenew ? "text-success" : "text-warning"}
/>
<span className="text-sm text-text-secondary">
Auto-renew {currentPlan?.autoRenew ? 'enabled' : 'disabled'}
</span>
</div>
<Button
onClick={()=>navigate('/billing')} 
variant="outline" size="sm">
Manage
</Button>
</div>
</div>


{/* Upgrade Options */}
<div>
<h4 className="font-medium text-text-primary mb-4">Change Plan</h4>
<div className="space-y-3">
{planCatalog
.filter(p => p.level !== currentLevel)          // hide current
.map(plan => {
const isUpgrade = plan.level > currentLevel;
return (
<div
key={plan.name}
className={`border rounded-lg p-3 spring-transition hover:border-primary/30 ${
plan.popular ? 'border-primary/20 bg-primary/5' : 'border-border'
}`}
>
<div className="flex items-center justify-between">
<div>
<div className="flex items-center space-x-2">
<h5 className="font-medium text-text-primary capitalize">{plan.name}</h5>
{plan.popular && (
<span className="px-2 py-1 bg-primary text-primary-foreground text-xs rounded-full">
Popular
</span>
)}
</div>
<p className="text-sm text-text-secondary">{plan.description}</p>
<p className="text-sm font-medium text-primary mt-1">
${plan.price}/{plan.period}
</p>
</div>

<Button
variant={plan.popular ? 'default' : 'outline'}
size="sm"
onClick={() => handleUpgrade(plan)}
>
{isUpgrade ? 'Upgrade' : 'Downgrade'}
</Button>
</div>
</div>
);
})}
</div>
</div>
{/* End Upgrade Options */}

</div>
);
};

export default SubscriptionStatus;